import { getCurrentLanguageCode } from '@translations/functions';
import { useGetArticlesQuery } from '@api/authApi';
import { GridError, GridLoading, GridEmpty } from '@components/grid-elements/GridElements';
import { GridHeader } from '@pages/admin/article-list/grid/GridHeader';
import { GridRow } from '@pages/admin/article-list/grid/GridRow';



export const Grid = () => {
	
	const languageCode = getCurrentLanguageCode();
	const { data, isLoading, isFetching, isError, isSuccess } = useGetArticlesQuery({ country: languageCode });

	if (isLoading || isFetching) return (
		<div className='app-grid articles-grid'>
			<GridHeader />
			<GridLoading />
		</div>
	);

	if (isError || !data) return (
		<div className='app-grid articles-grid'>
			<GridHeader />
			<GridError />
		</div>
	);

	if (isSuccess && data && data.length === 0) return (
		<div className='app-grid articles-grid'>
			<GridHeader />
			<GridEmpty />
		</div>
	);

	return (
		<div className='app-grid articles-grid'>
			<GridHeader />
			{data && data.map((x,i) =>
				<GridRow
					key={x.guid}
					item={x}
					rowIndex={i} />)}
		</div>
	);
};